
import { defineComponent, isProxy, PropType } from "vue";
import { Parameter, parameterType, parameterSubtype } from "@/types/parameter.type";
import { AppError } from "@/types/app.type";
import { ElForm } from "element-plus";
import { saveParameter } from "@/service/parameter.service";

interface ListOptions {
  value: string;
  label: string;
}

export default defineComponent({
  props: {
    parameterData: {
      type: Object as PropType<Parameter>,
    },
  },
  data() {
    return {
      parameterForm: {} as Parameter,
      rules: {
        name: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
      },
      instrumentationRange: [0, 0],
      physicalRange: [0, 0],
      typeOptions: [] as ListOptions[],
      subtypeOptions: [] as ListOptions[],
    };
  },
  setup() {
    const listType = [parameterType.STATION, parameterType.SAMPLINGPOINT];
    const listQuality = [
      parameterSubtype.QUALITY,
      parameterSubtype.METEOROLOGY,
      parameterSubtype.QUANTITY,
      parameterSubtype.DATA_IMAGE,
      parameterSubtype.FLOATING,
      parameterSubtype.TMOA,
    ];
    const listStation = [parameterSubtype.ENVIRONMENTAL, parameterSubtype.OPERATIONAL];
    return { listType, listQuality, listStation };
  },
  mounted() {
    if (isProxy(this.parameterData)) {
      // - set form properties
      this.parameterForm = Object.assign({}, this.parameterData);
      this.initializeSubtype(false);
    }
    this.typeOptions = this.listType.map((item) => {
      return {
        value: `${parameterType[item]}`,
        label: this.$t(`parameterType.${parameterType[item].toLowerCase()}`),
      };
    });
    // asinamos el rango fisico al formulario
    if (
      this.parameterForm.physicalRange !== undefined &&
      this.parameterForm.physicalRange !== null
    ) {
      this.physicalRange[0] = this.parameterForm.physicalRange[0];
      this.physicalRange[1] = this.parameterForm.physicalRange[1];
    } else {
      this.physicalRange = [0, 0];
      this.parameterForm.physicalRange = [0, 0];
    }
  },
  methods: {
    async doSave(): Promise<Parameter | undefined> {
      const valid = await (this.$refs["form"] as InstanceType<typeof ElForm>).validate();
      if (!valid) {
        throw new Error(AppError.FORM_VALIDATION);
      }

      if (
        this.parameterForm.physicalRange !== undefined &&
        this.parameterForm.physicalRange !== null
      ) {
        if (this.physicalRange[0] == 0 && this.physicalRange[1] == 0) {
          this.parameterForm.physicalRange = null;
        } else {
          this.parameterForm.physicalRange = this.physicalRange;
          this.parameterForm.instrumentationRange = this.instrumentationRange;
        }
      }
      return saveParameter(this.parameterForm);
    },

    initializeSubtype(reset = true) {
      if (reset) {
        this.parameterForm.subtype = undefined;
      }
      if (parameterType[this.parameterForm.type] === parameterType.STATION) {
        this.subtypeOptions = this.listStation
          .map((item) => {
            return {
              value: `${parameterSubtype[item]}`,
              label: this.$t(`parameterType.${parameterSubtype[item].toLowerCase()}`),
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label));
      } else if (parameterType[this.parameterForm.type] === parameterType.SAMPLINGPOINT) {
        this.subtypeOptions = this.listQuality
          .map((item) => {
            return {
              value: `${parameterSubtype[item]}`,
              label: this.$t(`parameterType.${parameterSubtype[item].toLowerCase()}`),
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label));
      }
    },
  },
});
